module.exports = __webpack_public_path__ + "static/media/bluefish1.f18fc778.png";